"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactPose = _interopRequireDefault(require("react-pose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ContentBackdrop = _interopRequireDefault(require("./ContentBackdrop"));

var _ModalViewContent = _interopRequireDefault(require("./ModalViewContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledModalView = (0, _styledComponents.default)(_reactPose.default.div({
  visible: {
    height: 'auto',
    transition: {
      duration: 0
    }
  },
  hidden: {
    height: 0,
    transition: {
      duration: 0
    }
  }
})).withConfig({
  displayName: "ModalView__StyledModalView",
  componentId: "sc-1o4zg1q-0"
})(["position:absolute;top:0;right:0;bottom:0;left:0;display:flex;justify-content:center;"]);

const ModalView = ({
  children,
  show,
  onClose
}) => /*#__PURE__*/_react.default.createElement(StyledModalView, {
  pose: show ? 'visible' : 'hidden'
}, /*#__PURE__*/_react.default.createElement(_ContentBackdrop.default, {
  show: show,
  onClose: onClose
}, /*#__PURE__*/_react.default.createElement(_ModalViewContent.default, null, children)));

var _default = (0, _styledComponents.default)(ModalView).withConfig({
  displayName: "ModalView",
  componentId: "sc-1o4zg1q-1"
})([""]);

exports.default = _default;